<template>
  <div class="load-indicator" ref="container">
    <div
      class="outer-circle"
      :style="{ backgroundColor: outerColor, width: circleSize, height: circleSize }"
      v-tooltip="{
                content: tooltip || '',
                delay: { show: 700, hide: 0 },
                classes: 'large',
              }"
    >
      <div class="inner-circle" :style="{  transform: 'scale(' + Math.min(load, 1) + ')', backgroundColor: innerColor }"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LoadIndicator',
  props: {
    load: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: '30px'
    },
    tooltip: {
      type: String
    }
  },
  data: () => ({shown: false}),
  computed: {
    rgbColor() {
      if (this.load < 0.4) {
        return '105, 201, 105'
      } else if (this.load >= 0.4 && this.load < 0.8) {
        return '0, 128, 0';
      } else if (this.load >= 0.8 && this.load < 1) {
        return '255, 165, 0';
      } else if (this.load >= 1) {
        return '255, 0, 0';
      }
      return '144, 238, 144';
    },
    innerColor() {
      return `rgb(${this.rgbColor})`;
    },
    outerColor() {
      return `rgba(${this.rgbColor}, 0.4)`;
    },
    circleSize() {
      if (this.size) return this.size;
      // TODO: responsive indicator size in case no size is specified, this won't be triggered since size prop has default
      const container = this.$refs.container;
      const size = Math.min(container.offsetWidth, container.offsetHeight);
      return `${Math.max(size, 30)}px`;
    },
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';
.load-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
}

.outer-circle {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  min-width: 30px;
  min-height: 30px;
  max-width: 100px;
  max-height: 100px;
  border-radius: 50%;
}

.inner-circle {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
}
</style>
